(() => {
  if (window.juniorJourneyReady) return;
  window.juniorJourneyReady = true;
  let columns = '1';
  try { columns = localStorage.getItem('junior-grid-columns') === '2' ? '2' : '1'; } catch (_) {}
  function syncGrid() {
    document.querySelectorAll('[data-junior-grid]').forEach(grid => {
      grid.dataset.juniorGrid = columns;
      grid.querySelector('.jr-grid-controls')?.setAttribute('data-ready', '');
      grid.querySelectorAll('[data-junior-columns]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.juniorColumns === columns)));
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-junior-columns]');
    if (!button) return;
    columns = button.dataset.juniorColumns === '2' ? '2' : '1';
    try { localStorage.setItem('junior-grid-columns', columns); } catch (_) {}
    syncGrid();
  });
  syncGrid();
  document.addEventListener('junior:results-updated', syncGrid);
  document.addEventListener('shopify:section:load', syncGrid);

  if (!customElements.get('junior-sticky-buy')) customElements.define('junior-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(this.dataset.sectionId);
      this.main = this.section?.querySelector('.product__information button[name="add"]');
      this.action = this.querySelector('[data-jr-sticky-submit]');
      if (!this.main || !this.action) return;
      this.titleEl = this.querySelector('strong');
      this.defaultTitle = this.titleEl?.textContent;
      this.sync = () => {
        const rect = this.main.getBoundingClientRect();
        // Only once the main button has scrolled up out of view, so the bar never covers the buy box.
        this.hidden = rect.height === 0 || rect.bottom > 0;
        this.action.disabled = this.main.disabled || this.main.getAttribute('aria-busy') === 'true' || this.main.classList.contains('is-loading');
        this.action.textContent = this.main.querySelector('.text')?.textContent.trim() || this.main.textContent.trim();
        // Make it a set can point the main button at a set; the bar then names that set and its price.
        if (this.titleEl) this.titleEl.textContent = this.main.dataset.jrStickyTitle || this.defaultTitle;
        const price = this.section.querySelector('.modal_price .price .money, .modal_price [data-price] .money');
        if (this.main.dataset.jrStickyPrice) this.querySelector('[data-jr-sticky-price]').textContent = this.main.dataset.jrStickyPrice;
        else if (price) this.querySelector('[data-jr-sticky-price]').textContent = price.textContent.trim().replace(/\.00\b/, '');
      };
      this.onClick = () => { if (!this.main.disabled) this.main.click(); };
      this.action.addEventListener('click', this.onClick);
      this.intersection = new IntersectionObserver(this.sync, {rootMargin:'0px 0px -90px 0px',threshold:[0,1]});
      this.intersection.observe(this.main);
      this.mutation = new MutationObserver(this.sync);
      this.mutation.observe(this.main,{attributes:true,childList:true,subtree:true,characterData:true});
      const price = this.section.querySelector('.modal_price');
      if (price) this.mutation.observe(price,{childList:true,subtree:true,characterData:true});
      this.sync();
    }
    disconnectedCallback() { this.intersection?.disconnect(); this.mutation?.disconnect(); this.action?.removeEventListener('click',this.onClick); }
  });

  // Share the occupied bottom space with the existing native chat styling.
  let scheduled = false;
  const bars = new Set();
  const measure = () => {
    scheduled = false;
    let occupied = 0;
    bars.forEach(bar => {
      if (!bar.isConnected) { size.unobserve(bar); bars.delete(bar); return; }
      if (!bar.hidden && getComputedStyle(bar).visibility !== 'hidden') {
        const rect = bar.getBoundingClientRect();
        if (rect.height) occupied = Math.max(occupied, innerHeight - rect.top + 12);
      }
    });
    document.documentElement.style.setProperty('--gp-sticky-cart-height', `${Math.ceil(occupied)}px`);
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(measure); } };
  const size = new ResizeObserver(schedule);
  const changes = new MutationObserver(schedule);
  function trackBars() {
    document.querySelectorAll('.jr-shop-sticky, .jr-sticky-buy, [data-compare-bar]').forEach(bar => {
      if (bars.has(bar)) return;
      bars.add(bar); size.observe(bar); changes.observe(bar,{attributes:true,attributeFilter:['hidden','class']});
    });
    schedule();
  }
  trackBars();
  document.addEventListener('junior:results-updated', trackBars);
  document.addEventListener('shopify:section:load', trackBars);
  window.addEventListener('resize', schedule, {passive:true});
})();
